import { useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { LoginCard } from '../components/LoginCard'
import { ProductionDashboardStub } from './ProductionDashboardStub'
import { loadingClass, loginPageClass } from '../lib/ui'

/**
 * `/`: неавторизованным — форма входа; авторизованным — заглушка дашборда по производству.
 */
export function HomePage() {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className={loadingClass}>
        <p>Загрузка…</p>
      </div>
    )
  }

  if (!user) {
    const from = (location.state as { from?: string } | null)?.from
    const afterLogin = from && from.startsWith('/') ? from : '/'

    return (
      <div className={loginPageClass}>
        <LoginCard afterLoginTo={afterLogin} />
      </div>
    )
  }

  return <ProductionDashboardStub />
}
